import { REGISTER_DEVICE_SUCCESS } from './device'
import { RESET } from '../redux/game'
// Actions
const TOGGLE_SIDEBAR = 'ascension/ui/sidebar/toggle'
const CHANGE_ROUTE = 'ascension/ui/sidebar/change_route'
const UPDATE_SIDEBAR_FONT_SIZE = 'ascension/ui/sidebar/update-font-size'

const widthForFontSize = {
  s: 200,
  m: 250,
  l: 300
}
// Reducer
const initialState = {
  sidebarMinimised: false,
  sidebarWidth: 250,
  currentTab: 'Summary',
  sideBarFontSize: 'm'
}

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case TOGGLE_SIDEBAR: {
      return {
        ...state,
        sidebarMinimised: !state.sidebarMinimised
      }
    }
    case CHANGE_ROUTE: {
      return {
        ...state,
        currentTab: action.data
      }
    }
    case UPDATE_SIDEBAR_FONT_SIZE: {
      return {
        ...state,
        sidebarWidth: widthForFontSize[action.data],
        sideBarFontSize: action.data
      }
    }
    case REGISTER_DEVICE_SUCCESS: {
      return {
        ...state,
        sidebarWidth: widthForFontSize[action.data.sideBarFontSize],
        sideBarFontSize: action.data.sideBarFontSize
      }
    }
    case RESET: {
      return initialState
    }
    default: return state
  }
}

export default reducer

// Action Creators

export function toggleSidebar () {
  return {
    type: TOGGLE_SIDEBAR
  }
}

export function changeRoute (route) {
  return {
    type: CHANGE_ROUTE,
    data: route
  }
}

export function updateFontSize (fontSize) {
  return {
    type: UPDATE_SIDEBAR_FONT_SIZE,
    data: fontSize
  }
}
